import moment from 'moment';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let parseNonString = (item, alt) => {
  item = typeof item !== "string"
  ? JSON.stringify(item)
  : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    item = alt;
  }

  if (item == null) {
    item = alt;
  }

  return item;
};

let initLog = () => {
  let log = parseNonString(localStorage.getItem("log"), []);

  if (log && Array.isArray(log) && log.length > 0) {
    //Filter out all data that is older than an hour.
    let now = new Date();
    log = log.filter(item => {
      return moment(item.eventTime) > moment(now).subtract(1, "hours");
    })
  } else {
    log = [{
      eventTime: new Date(),
      message: 'Started logging'
    }];
  }

  return log;
}

let initTokenExpiration = () => {
  var time = null;
  if (localStorage.getItem("tokenExpiration")) {
    try {
      time = new Date(JSON.parse(localStorage.getItem("tokenExpiration")));
    } catch {}
  } else if (localStorage.getItem("expirationTime")) {
    try {
      time = new Date(localStorage.getItem("expirationTime"))
    } catch {}
  }
  return time;
}

export const store = new Vuex.Store({
  state: {
    authenticated: parseNonString(localStorage.getItem("authenticated"), false),
    authProvider: localStorage.getItem("authProvider") == null ? "" : localStorage.getItem("authProvider"),
    user: parseNonString(localStorage.getItem("user"), null),
    token: localStorage.getItem("token") == null ? "" : JSON.parse(localStorage.getItem("token")),
    tokenExpiration: initTokenExpiration(),
    setup: parseNonString(localStorage.getItem("setup"), false),
    pauseAuth: parseNonString(localStorage.getItem("pauseAuth"), false),
    authError: localStorage.getItem("authError") == null ? "" : localStorage.getItem("authError"),
    authErrorTimer: localStorage.getItem("authErrorTimer") ? new Date(JSON.parse(localStorage.getItem("authErrorTimer"))) : null,
    context: parseNonString(localStorage.getItem("context"), null),
    loginPopup: false,
    returnUrl: localStorage.getItem("returnUrl") == null ? "" : localStorage.getItem("returnUrl"),
    refreshTimer: localStorage.getItem("refreshTimer") ? new Date(JSON.parse(localStorage.getItem("refreshTimer"))) : null,
    log: initLog(),
    tenantId: localStorage.getItem("tenantId") == null ? "" : localStorage.getItem("tenantId"),
    currentSurvey: localStorage.getItem("currentSurvey") == null ? "" : localStorage.getItem("currentSurvey"),
    dataLoading: true,
    dataLoaded: false,
  },
  mutations: {
    SET_AUTH_PROVIDER(state, payload) {
      state.authProvider = payload;
      localStorage.setItem("authProvider", payload);
    },
    SET_AUTHENTICATED(state, payload) {
      state.authenticated = payload;
      localStorage.setItem("authenticated", payload);
    },
    SET_USER(state, payload) {
      state.user = payload;
      localStorage.setItem('user', JSON.stringify(payload));
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
      localStorage.setItem('token', JSON.stringify(payload));
    },
    SET_TOKEN_EXPIRATION(state, payload) {
      state.tokenExpiration = payload;
      localStorage.setItem('tokenExpiration', JSON.stringify(payload));
    },
    SET_PAUSE_AUTH(state, payload) {
      state.pauseAuth = payload;
      localStorage.setItem('pauseAuth', payload);
    },
    SET_AUTH_ERROR(state, payload) {
      state.authError = payload;
      localStorage.setItem('authError', payload);
      if (payload !== "") {
        let date = new Date();
        state.authErrorTimer = date;
        localStorage.setItem('authErrorTimer', JSON.stringify(date));
      } else {
        state.authErrorTimer = null;
        localStorage.setItem('authErrorTimer', null);
      }
    },
    SET_CONTEXT(state, payload) {
      state.context = payload;
      localStorage.setItem('context', JSON.stringify(payload));
    },
    SET_LOGIN_POPUP(state, payload) {
      state.loginPopup = payload;
    },
    SET_RETURN_URL(state, payload) {
      state.url = payload;
      localStorage.setItem('returnUrl', payload);
    },
    SET_REFRESH_TIMER(state, payload) {
      state.refreshTimer = payload;
      localStorage.setItem('refreshTimer', JSON.stringify(payload));
    },
    SET_TENANT_ID(state, payload){
      state.tenantId = payload;
      localStorage.setItem('tenantId', payload);
    },
    SET_CURRENT_SURVEY(state, payload){
      state.currentSurvey = payload;
      localStorage.setItem('currentSurvey', payload);
    },
    LOG(state, payload) {
      let entry = {
        eventTime: new Date(),
        message: payload
      }
      state.log.push(entry);
      localStorage.setItem("log", JSON.stringify(state.log));
    },
    SET_DATA_LOADED: (state, bool) => {
      state.dataLoaded = bool;
    },
    SET_DATA_LOADING: (state, bool) => {
      state.dataLoading = bool;
    },
  },
  actions : {
    setAuthProvider(ctx, payload) {
      ctx.commit('SET_AUTH_PROVIDER', payload);
    },
    setAuthenticated(ctx, payload) {
      ctx.commit('SET_AUTHENTICATED', payload);
    },
    setUser(ctx, payload) {
      ctx.commit('SET_USER', payload);
    },
    setToken(ctx, payload) {
      ctx.commit('SET_TOKEN', payload);
    },
    setTokenExpiration(ctx, payload) {
      ctx.commit('SET_TOKEN_EXPIRATION', payload);
    },
    setPauseAuth(ctx, payload) {
      ctx.commit('SET_PAUSE_AUTH', payload);
    },
    setAuthError(ctx, payload) {
      ctx.commit('SET_AUTH_ERROR', payload);
    },
    setContext(ctx, payload) {
      ctx.commit('SET_CONTEXT', payload);
    },
    setLoginPopup(ctx, payload) {
      ctx.commit('SET_LOGIN_POPUP', payload);
    },
    setReturnUrl(ctx, payload) {
      ctx.commit('SET_RETURN_URL', payload);
    },
    setRefreshTimer(ctx, payload) {
      ctx.commit('SET_REFRESH_TIMER', payload);
    },
    setTenantId(ctx, payload) {
      ctx.commit('SET_TENANT_ID', payload);
    },
    setCurrentSurvey(ctx, payload) {
      ctx.commit('SET_CURRENT_SURVEY', payload);
    },
    clearSession(ctx) {
      ctx.commit('SET_TENANT_ID', "");
      ctx.commit('SET_CONTEXT', null);
      ctx.commit('SET_USER', null);
      ctx.commit('SET_AUTH_PROVIDER', "");
      ctx.commit('SET_AUTHENTICATED', false);
      ctx.commit('SET_TOKEN', "")
      ctx.commit('SET_TOKEN_EXPIRATION', null);
      ctx.commit('SET_PAUSE_AUTH', false);
      ctx.commit('SET_LOGIN_POPUP', false);
      ctx.commit('SET_CURRENT_SURVEY', "");
    },
    log(ctx, payload) {
      ctx.commit('LOG', payload);
    },
    resetLoading(ctx) {
      ctx.commit("SET_DATA_LOADING", true);
      ctx.commit("SET_DATA_LOADED", false);
    },
    dataLoaded(ctx) {
      ctx.commit("SET_DATA_LOADING", false);
      ctx.commit("SET_DATA_LOADED", true);
    },
  },
  getters: {
    getAuthProvider: state => state.authProvider,
    getAuthenticated: state => state.authenticated,
    getUser: state => state.user,
    getToken: state => state.token,
    getTokenExpiration: state => state.tokenExpiration,
    getPauseAuth: state => state.pauseAuth,
    getAuthError(state) {
      var now = new Date();
      if (Math.abs(now - state.authErrorTimer) > 60 * 1000) {
        state.authError = "";
        localStorage.setItem("authError", "");
        state.authErrorTimer = null;
        localStorage.setItem("authErrorTimer", null);
      }
      return state.authError;
    },
    getContext: state => state.context,
    getLoginPopup: state => state.loginPopup,
    getReturnUrl: state => state.returnUrl,
    getLog: state => state.log,
    getRefreshTimer: state => state.refreshTimer,
    getTenantId: state => state.tenantId,
    getCurrentSurvey: state => state.currentSurvey,
    getDataLoading: state => state.dataLoading,
    getDataLoaded: state => state.dataLoaded,
  }
});